import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import { Card, Flex, Heading1 } from 'adl'
import { Link } from 'react-router-dom'

import numeral from 'numeral'

import StandardLayout from 'components/layouts/Standard'
import ListItem from 'components/ListItem'
import MockCard from 'components/MockCard'
import MarketingTile from 'components/MarketingTile'

const FrozenLine = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: ${props => props.theme.colors.danger};
`

const FrozenText = styled.div`
  font-size: 0.8rem;
  font-weight: 500;
  color: ${props => props.theme.colors.danger};
`

const AccountListItem = ({
  id,
  nickname,
  balance,
  mask,
  provider,
  hideAmount,
  frozen
}) => {
  return (
    <ListItem>
      {frozen && <FrozenLine />}
      <Flex justify="space-between">
        <div>
          <Flex>
            <MockCard provider={provider} style={{ marginRight: '1rem' }} />
            <div>
              <ListItem.LargeLink to={`/card-details/${id}`} as={Link}>
                {nickname}
              </ListItem.LargeLink>
              <ListItem.SubText>{mask ? '••••' + mask : null}</ListItem.SubText>
            </div>
          </Flex>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }}
        >
          <div style={{ textAlign: 'right' }}>
            {!hideAmount && (
              <ListItem.LargeText>
                {numeral(balance).format('$0,0.00')}
              </ListItem.LargeText>
            )}
            {frozen && <FrozenText>Frozen</FrozenText>}
          </div>
        </div>
      </Flex>
    </ListItem>
  )
}

const cardsMarketingData = {
  title: 'Fantastic Plastic',
  body: 'Establish or rebuild credit with a Secured Visa®',
  image: require('images/marketing/credit-card.jpg')
}

export default () => {
  const cards = useSelector(state => state.cards.cards || [])
  const creditCards = cards.filter(c => c.type === 'credit')
  const debitCards = cards.filter(c => c.type === 'debit')

  return (
    <StandardLayout>
      <Heading1>Manage Cards</Heading1>

      <div style={{ maxWidth: 768 }}>
        <MarketingTile
          {...cardsMarketingData}
          style={{ marginBottom: '2rem' }}
        />

        {creditCards && creditCards.length > 0 && (
          <Card elevation={2}>
            <Card.Header>
              <Flex justify="space-between">
                <div>Credit Cards</div>
                <div>Current Balance</div>
              </Flex>
            </Card.Header>
            {creditCards.map((a, index) => (
              <AccountListItem key={index} {...a} />
            ))}
          </Card>
        )}

        {debitCards && debitCards.length > 0 && (
          <Card elevation={2}>
            <Card.Header>
              <div>Debit Cards</div>
            </Card.Header>
            {debitCards.map((a, index) => (
              <AccountListItem hideAmount key={index} {...a} />
            ))}
          </Card>
        )}
      </div>
    </StandardLayout>
  )
}
